define(function (require) {
    "use strict";


    function extend(obj, extendObj, deep) {
        var newObj;

        if (!obj || "object" !== typeof obj) {
            return obj;
        }

        if (!extendObj) {
            return clone(obj);
        }

        newObj = extendObj || obj.constructor() || {};
        for (var prop in obj) {

            // Prevent never-ending loop
            if (newObj[prop] === obj[prop]) {
                continue;
            }

            if (obj.hasOwnProperty(prop)) {
                newObj[prop] = deep ? extend(obj[prop], void 0, deep) : obj[prop];
            }
        }

        return newObj;
    }

    function clone(obj) {
        try {
            return JSON.parse(stringify(obj));
        }
        catch (e) {
            //logger.error('unable to clone object:' + JSON.stringify(e));
        }
    }

    function stringify(value) {
        var stringified, toJSONPrototype;
        if (typeof Array.prototype.toJSON === 'function') {
            toJSONPrototype = Array.prototype.toJSON;
            delete Array.prototype.toJSON;
            try {
                stringified = JSON.stringify(value);
            } catch (e) {
                Array.prototype.toJSON = toJSONPrototype;
                throw e;
            }
            Array.prototype.toJSON = toJSONPrototype;
        } else {
            stringified = JSON.stringify(value);
        }
        return stringified;
    }

    function isEmpty(obj) {
        return (!obj || (!obj.length && !Object.keys(obj).length));
    }

    return {
        stringify: stringify,
        extend: extend,
        clone: clone,
        isEmpty: isEmpty
    };
});
